const { hasParentFrame, sendMessage, onMessage } = require("../frame-manager");

const API_UNAUTHORIZED_MESSAGE_NAME = "sinao:api:unauthorized-thrown";

function apiUnauthorizedThrown() {
	if (hasParentFrame) {
		return sendMessage(API_UNAUTHORIZED_MESSAGE_NAME);
	}

	/*
	if (window.location.pathname !== "/login") {
		window.location.href = "/login";
	}
	*/
}

onMessage(API_UNAUTHORIZED_MESSAGE_NAME, apiUnauthorizedThrown);

module.exports = apiUnauthorizedThrown;
